import React from 'react';
import { ArrowRight } from 'lucide-react';
export const HeroSection = () => {
  return <section className="pt-24 pb-16 md:pt-32 md:pb-24 bg-gradient-to-br from-aspira-navy to-aspira-blue text-white" data-id="element-79">
      <div className="container mx-auto px-4 md:px-6" data-id="element-80">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-81">
          <div className="space-y-6 md:space-y-8" data-id="element-82">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight" data-id="element-83">
              Strategies for <span className="text-aspira-green" data-id="element-84">Growth</span>{' '}
              and <span className="text-aspira-green" data-id="element-85">Success</span>
            </h1>
            <p className="text-lg md:text-xl text-aspira-white opacity-90" data-id="element-86">
              We help businesses achieve and sustain growth by identifying
              opportunities, streamlining operations, and charting a course to
              achieve your ambitions.
            </p>
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-87">
              <a href="#contact" className="bg-aspira-green hover:bg-opacity-90 text-white px-6 py-3 rounded-md transition-colors font-medium text-center inline-flex items-center justify-center" data-id="element-88">
                Get Started <ArrowRight size={18} className="ml-2" data-id="element-89" />
              </a>
              <a href="#services" className="border border-white hover:bg-white hover:bg-opacity-10 text-white px-6 py-3 rounded-md transition-colors font-medium text-center" data-id="element-90">
                Our Services
              </a>
            </div>
          </div>
          <div className="hidden md:block" data-id="element-91">
            <div className="relative" data-id="element-92">
              <div className="absolute -top-6 -left-6 w-24 h-24 bg-aspira-green rounded-full opacity-20" data-id="element-93"></div>
              <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-aspira-orange rounded-full opacity-20" data-id="element-94"></div>
              <div className="relative bg-white bg-opacity-10 backdrop-blur-sm p-8 rounded-xl border border-white border-opacity-20" data-id="element-95">
                <h3 className="text-2xl font-bold mb-4 text-aspira-green" data-id="element-96">
                  Aspire, Grow, Succeed
                </h3>
                <ul className="space-y-3" data-id="element-97">
                  <li className="flex items-start" data-id="element-98">
                    <div className="bg-aspira-green rounded-full p-1 mr-3 mt-1" data-id="element-99">
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-100">
                        <path d="M20 6L9 17L4 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-101" />
                      </svg>
                    </div>
                    <span data-id="element-102">Strategic growth consulting</span>
                  </li>
                  <li className="flex items-start" data-id="element-103">
                    <div className="bg-aspira-green rounded-full p-1 mr-3 mt-1" data-id="element-104">
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-105">
                        <path d="M20 6L9 17L4 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-106" />
                      </svg>
                    </div>
                    <span data-id="element-107">CFO services</span>
                  </li>
                  <li className="flex items-start" data-id="element-108">
                    <div className="bg-aspira-green rounded-full p-1 mr-3 mt-1" data-id="element-109">
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-110">
                        <path d="M20 6L9 17L4 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-111" />
                      </svg>
                    </div>
                    <span data-id="element-112">Operations optimization</span>
                  </li>
                  <li className="flex items-start" data-id="element-113">
                    <div className="bg-aspira-green rounded-full p-1 mr-3 mt-1" data-id="element-114">
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-115">
                        <path d="M20 6L9 17L4 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-116" />
                      </svg>
                    </div>
                    <span data-id="element-117">Strategic recruiting</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};